<template>
    <div class="incubator-proposal">
        <v-form
            ref="form"
            v-model="valid"
        >
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        {{ $t('IncubatorApply.Proposal.title[0]') }}
                    </div>
                </div>
                <div class="form-content">
                    <div class="form-row">
                        <v-text-field
                            v-model="form.proposal.name"
                            outlined
                            :label="$t('IncubatorApply.Proposal.label[0]')"
                            placeholder=""
                            :hint="$t('IncubatorApply.Proposal.hint[0]')"
                            persistent-hint
                            :rules="emptyRule"
                            class="border-orange-input form-input"
                        />
                    </div>
                </div>
            </div>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        {{ $t('IncubatorApply.Proposal.title[1]') }}
                    </div>
                </div>
                <div class="form-content">
                    <v-radio-group
                        v-model="form.proposal.property"
                        class="radio-group"
                        :rules="emptyRule"
                    >
                        <v-radio
                            value="臺灣團隊-孵化組"
                            color="#F97E2B"
                        >
                            <template v-slot:label>
                                <div class="radio-label">
                                    {{ $t('IncubatorApply.Proposal.radio[0]') }}
                                </div>
                            </template>
                        </v-radio>
                        <div class="radio-content">
                            <p>{{ $t('IncubatorApply.Proposal.content[0]') }}</p>
                            <p>{{ $t('IncubatorApply.Proposal.content[1]') }}</p>
                            <ol>
                                <li>{{ $t('IncubatorApply.Proposal.content[2]') }}</li>
                                <li>{{ $t('IncubatorApply.Proposal.content[3]') }}</li>
                                <li>{{ $t('IncubatorApply.Proposal.content[4]') }}</li>
                                <li>{{ $t('IncubatorApply.Proposal.content[5]') }}</li>
                            </ol>
                        </div>
                        <v-radio
                            value="臺灣團隊-加速組"
                            color="#F97E2B"
                        >
                            <template v-slot:label>
                                <div class="radio-label">
                                    {{ $t('IncubatorApply.Proposal.radio[1]') }}
                                </div>
                            </template>
                        </v-radio>
                        <div class="radio-content">
                            <p>{{ $t('IncubatorApply.Proposal.content[6]') }}</p>
                            <p>{{ $t('IncubatorApply.Proposal.content[7]') }}</p>
                            <ol>
                                <li>{{ $t('IncubatorApply.Proposal.content[8]') }}</li>
                                <li>{{ $t('IncubatorApply.Proposal.content[9]') }}</li>
                                <li>{{ $t('IncubatorApply.Proposal.content[10]') }}</li>
                                <li>{{ $t('IncubatorApply.Proposal.content[11]') }}</li>
                            </ol>
                        </div>
                        <!-- 本屆無亞太地區團隊，暫時隱藏；恢復時將 showAsiaPacific 改回 true -->
                        <template v-if="showAsiaPacific">
                            <v-radio
                                value="亞太地區團隊"
                                color="#F97E2B"
                            >
                                <template v-slot:label>
                                    <div class="radio-label">
                                        {{ $t('IncubatorApply.Proposal.radio[2]') }}
                                    </div>
                                </template>
                            </v-radio>
                            <div class="radio-content">
                                <ol>
                                    <li>{{ $t('IncubatorApply.Proposal.content[12]') }}</li>
                                    <li>{{ $t('IncubatorApply.Proposal.content[13]') }}</li>
                                    <li>{{ $t('IncubatorApply.Proposal.content[14]') }}</li>
                                    <li>{{ $t('IncubatorApply.Proposal.content[15]') }}</li>
                                </ol>
                            </div>
                        </template>
                    </v-radio-group>
                </div>
            </div>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        {{ $t('IncubatorApply.Proposal.title[2]') }}
                    </div>
                </div>
                <div class="form-content">
                    <v-textarea
                        v-model="form.proposal.abstract"
                        rows="10"
                        :counter="500"
                        :counter-value="() => abstractWordCount"
                        :label="$t('IncubatorApply.Proposal.label[1]')"
                        no-resize
                        :rules="abstractRule"
                        outlined
                        placeholder=""
                        :hint="$t('IncubatorApply.Proposal.hint[1]')"
                        persistent-hint
                    />
                </div>
            </div>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        {{ $t('IncubatorApply.Proposal.title[3]') }}
                    </div>
                </div>
                <div class="form-content">
                    <v-radio-group
                        v-model="form.proposal.issue"
                        class="radio-group"
                        :rules="emptyRule"
                    >
                        <v-radio
                            v-for="item in issueOptions"
                            :key="item.value"
                            :value="item.value"
                            color="#F97E2B"
                        >
                            <template v-slot:label>
                                <div class="radio-label">
                                    {{ $t(item.label) }}
                                </div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </div>
            </div>
            <div class="apply-form-block team-image-block">
                <div class="left-block">
                    <div class="block-title">
                        {{ $t('IncubatorApply.Proposal.title[4]') }}
                    </div>
                </div>
                <div class="form-content">
                    <div class="label">
                        {{ $t('IncubatorApply.Proposal.label[2]') }}
                    </div>
                    <v-card
                        elevation="4"
                        class="preview-card rounded-lg"
                    >
                        <v-tooltip
                            top
                            nudge-top="-90"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-img
                                    id="img-file"
                                    height="300px"
                                    :src="$static(form.proposal.img)"
                                    class="og-image"
                                    :contain="loading"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-file-input
                                        v-model="proposalImg"
                                        accept="image/png, image/jpeg"
                                        class="upload pa-0 ma-0"
                                        hide-input
                                        truncate-length="0"
                                        prepend-icon="mdi-upload"
                                        dark
                                        :rules="[imgRule()]"
                                        @change="handleImageUpload"
                                    />
                                </v-img>
                            </template>
                            <span>{{ $t('IncubatorApply.Proposal.image') }}</span>
                        </v-tooltip>
                    </v-card>
                </div>
            </div>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        {{ $t('IncubatorApply.Proposal.title[5]') }}
                    </div>
                </div>
                <div class="form-content">
                    <v-file-input
                        v-model="tmpPdf"
                        accept=".pdf"
                        :label="$t('IncubatorApply.Proposal.label[3]')"
                        outlined
                        placeholder=""
                        :hint="$t('IncubatorApply.Proposal.hint[2]')"
                        persistent-hint
                        :rules="[pdfRule()]"
                        class="border-orange-input form-input"
                        @change="
                            (file) =>
                                handlePdfChange(`form.proposal.pdfFile`, file, form.proposal.tmpPdf)
                        "
                    />
                    <div
                        v-if="form.proposal.pdfFile"
                        class="preivew"
                    >
                        <a
                            :href="$static(form.proposal.pdfFile)"
                            target="_blank"
                            class="preview-link"
                        >{{ $t('IncubatorApply.Proposal.link') }}</a>
                    </div>
                </div>
            </div>
        </v-form>
        <div class="apply-form-block">
            <div class="left-block" />
            <div class="form-content">
                <div class="actions">
                    <div
                        class="btn white-btn"
                        @click="prevStep"
                    >
                        {{ $t('IncubatorApply.Proposal.button[0]') }}
                    </div>
                    <div
                        class="btn blue-btn"
                        @click="save"
                    >
                        {{ $t('IncubatorApply.Proposal.button[1]') }}
                    </div>
                    <div
                        class="btn orange-btn"
                        @click="nextStep"
                    >
                        {{ $t('IncubatorApply.Proposal.button[2]') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapMutations, mapActions } from 'vuex';
import { compress } from 'jpegasus';

export default {
    components: {},
    data() {
        return {
            valid: false,
            tmpPdf: null,
            // 本屆無亞太地區團隊，暫時隱藏；恢復時改為 true
            showAsiaPacific: false,
            // 本屆議題（5 項），順序對應 locale IncubatorApply.Proposal.radio[3..7]
            issueOptions: [
                { value: '慈善共好', label: 'IncubatorApply.Proposal.radio[3]' },
                { value: '健康福祉', label: 'IncubatorApply.Proposal.radio[4]' },
                { value: '教育創新', label: 'IncubatorApply.Proposal.radio[5]' },
                { value: '韌性城鄉', label: 'IncubatorApply.Proposal.radio[6]' },
                { value: '循環經濟', label: 'IncubatorApply.Proposal.radio[7]' },
            ],
            loading: false,
            proposalImg: null,
            // rules
            emptyRule: [(v) => !!v || this.$t('IncubatorApply.Proposal.rule[0]')],
            abstractRule: [
                (v) => !!v || this.$t('IncubatorApply.Proposal.rule[0]'),
                (v) => {
                    const wordCount = this.countWords(v);
                    return wordCount <= 500 || this.$t('IncubatorApply.Proposal.rule[1]');
                },
            ],
            twelveWordsRule: [
                (v) => !!v || this.$t('IncubatorApply.Proposal.rule[0]'),
                (v) => v.length <= 12 || this.$t('IncubatorApply.Proposal.rule[2]'),
            ],
            subsRule: [(v) => v.length >= 2 || this.$t('IncubatorApply.Proposal.rule[3]')],
            pdfRule() {
                if (this.tmpPdf && this.tmpPdf.type !== 'application/pdf') {
                    return this.$t('IncubatorApply.Proposal.rule[4]');
                }
                if (this.form.proposal.pdfFile) {
                    return true;
                }
                return this.$t('IncubatorApply.Proposal.rule[5]');
            },
            imgRule() {
                if (this.proposalImg || this.form.proposal.img) {
                    return true;
                }
                return this.$t('IncubatorApply.Proposal.rule[6]');
            },
        };
    },
    computed: {
        ...mapState('mIncubatorApply', ['form']),
        applyId() {
            return this.$route.params.id;
        },
        abstractWordCount() {
            return this.countWords(this.form.proposal.abstract);
        },
    },
    watch: {
        'form.proposal.property': {
            immediate: true,
            handler(value) {
                // 本屆隱藏亞太地區團隊，舊草稿若存有該值畫面上會看不到卻仍可送出，故清空
                if (!this.showAsiaPacific && value === '亞太地區團隊') {
                    this.form.proposal.property = '';
                    this.form.proposal.issue = '';
                }
            },
        },
        'form.proposal.issue': {
            immediate: true,
            handler(value) {
                // 舊草稿若存有本屆已下架的議題，畫面上顯示為未選取卻仍能通過必填驗證，故清空
                if (value && !this.issueOptions.some((item) => item.value === value)) {
                    this.form.proposal.issue = '';
                }
            },
        },
    },
    created() {},
    mounted() {},
    methods: {
        ...mapMutations('mNotification', ['handleError', 'setAlert']),
        ...mapActions('mIncubatorApply', ['saveProposal']),
        countWords(text) {
            if (!text) return 0;

            // 移除前後空白
            // eslint-disable-next-line no-param-reassign
            text = text.trim();

            // 匹配中文字符
            const chineseChars = text.match(/[\u4e00-\u9fa5\u3400-\u4dbf]/g) || [];

            // 匹配數字（每個數字算1）
            const numbers = text.match(/[0-9]/g) || [];

            // 移除中文字符和數字後的文本
            const textWithoutChineseAndNumbers = text.replace(/[\u4e00-\u9fa5\u3400-\u4dbf0-9]/g, ' ');

            // 計算英文單字數（只有連續的英文字母）
            const englishWords = textWithoutChineseAndNumbers.match(/[a-zA-Z]+/g) || [];

            // 總字數 = 中文字數 + 數字數 + 英文單字數
            return chineseChars.length + numbers.length + englishWords.length;
        },
        handlePdfChange(key, file, tmpKey) {
            if (!file) {
                _.set(this, key, '');
            }
            if (file) {
                if (file.size > 1024 * 1024 * 10) {
                    this.setAlert({
                        message: this.$t('alertMessage.data-10mb'),
                        color: 'error',
                    });
                    _.set(this, key, '');
                    _.set(this, tmpKey, '');
                    return;
                }
                _.set(this, key, URL.createObjectURL(file));
            }
        },
        prevStep() {
            this.$router.push({
                name: 'IncubatorTeamData',
                params: {
                    id: this.applyId,
                },
            });
        },
        save() {
            this.saveProposal({
                form: this.form.proposal,
                applyId: this.applyId,
            });
        },
        handleFiles(file) {
            return compress(file, {
                maxHeight: 800,
                maxWidth: 800,
                quality: 1,
                fixImageOrientation: false,
            });
        },
        async onUploadImage(key, file) {
            const compressFile = await this.handleFiles(file); // 可以找其他壓縮方式
            _.set(this, key, URL.createObjectURL(compressFile));
        },
        handleImageUpload(file) {
            if (file) {
                if (file.size > 1024 * 1024 * 2) {
                    this.setAlert({
                        message: this.$t('alertMessage.data-2mb'),
                        color: 'error',
                    });
                    return;
                }
                this.onUploadImage('form.proposal.img', file);
            }
        },
        async nextStep() {
            this.$refs.form.validate();
            if (this.valid) {
                try {
                    await this.saveProposal({
                        form: this.form.proposal,
                        applyId: this.applyId,
                    });
                    this.$router.push({
                        name: 'IncubatorConfirm',
                        params: {
                            id: this.applyId,
                        },
                    });
                } catch {
                    this.setAlert({
                        message: this.$t('alertMessage.data-no-write'),
                        color: 'error',
                    });
                }
            } else {
                this.setAlert({
                    message: this.$t('alertMessage.data-no-write'),
                    color: 'error',
                });
            }
        },
    },
};
</script>

<style lang="scss">
.incubator-proposal {
    .radio-content {
        padding-left: 34px;
        margin-bottom: 10px;

        p {
            margin-bottom: 4px;
        }

        ol {
            padding-left: 20px;
            margin-bottom: 0;
        }
    }

    .team-image-block {
        .preview-card {
            width: 300px;
            height: 300px;
        }

        .label {
            font-weight: 500;
            font-size: 18px;
            line-height: 18px;
            letter-spacing: 0.1em;
            color: $color-gray;
            margin-bottom: 23px;
        }

        .upload {
            position: absolute;
            z-index: 1;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: rgba(196, 196, 196, 0.4);
            border: 1px solid #ffffff;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            .v-input__prepend-outer {
                margin: 0 !important;
            }
        }
    }
}
#img-file {
    .v-input__control {
        display: block !important;
        position: absolute;
        top: 100%;
        width: 90px;
        text-align: center;
        .v-input__slot::before {
            display: none;
        }
    }
    .v-messages__wrapper{
        display: flex;
        justify-content:center;
    }
    .v-messages__message {
        display: inline;
        text-align: center;
    }
}
</style>
